export const URL_LOGO =
  "https://s3-us-west-1.amazonaws.com/phi-force.com/logo.png";
export const URL_GUIDE_PDF =
  "https://s3-us-west-1.amazonaws.com/phi-force.com/book/ebook.pdf";
export const URL_SONGS_PDF =
  "https://s3-us-west-1.amazonaws.com/phi-force.com/songs/songs.pdf";
export const COLOR_PURPLE = "#9147ff";
